import { types } from "mobx-state-tree";

const SchemaTabsEnum = types.enumeration(["pervideo", "livecontrol"]);
const CONNECTORS_COLLAPSED_KEY = "playgroundSidebarConnectorsCollapsed";

const getStoredConnectorsCollapsed = (): boolean => {
  try {
    return localStorage.getItem(CONNECTORS_COLLAPSED_KEY) === "true";
  } catch {
    return false;
  }
};

export const LayoutModel = types
  .model({
    schemaDrawerOpen: types.optional(types.boolean, false),
    activeSchemaTab: types.optional(SchemaTabsEnum, "pervideo"),
    connectorsPanelCollapsed: types.optional(
      types.boolean,
      getStoredConnectorsCollapsed
    ),
    layerVisualPanelCollapsed: types.optional(types.boolean, false),
  })
  .actions((self) => ({
    toggleSchemaDrawer() {
      self.schemaDrawerOpen = !self.schemaDrawerOpen;
    },
    setSchemaDrawerOpen(value: boolean) {
      self.schemaDrawerOpen = value;
    },
    setActiveSchemaTab(tab: "pervideo" | "livecontrol") {
      self.activeSchemaTab = tab;
    },
    setConnectorsPanelCollapsed(value: boolean) {
      self.connectorsPanelCollapsed = value;
      localStorage.setItem(CONNECTORS_COLLAPSED_KEY, value.toString());
    },
    setLayerVisualPanelCollapsed(value: boolean) {
      self.layerVisualPanelCollapsed = value;
    },
  }));
